import styled, { css } from 'styled-components';

export const MultiFactorAuthEnabledWrapper = styled.div(
  ({ theme: { spacers } }) => css`
    padding-top: ${spacers!.spacer03};
    padding-bottom: ${spacers!.spacer10};
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: InspireTWDC;
  `
);

export const Header = styled.div(
  ({ theme: { spacers, admanColors } }) => css`
    color: ${admanColors!.green.light.fg[1]};
    padding-bottom: ${spacers!.spacer02};
    display: flex;
    align-items: center;
  `
);

export const HeaderText = styled.div(
  ({ theme: { spacers } }) => css`
    padding-left: ${spacers!.spacer02};
    font-weight: 600;
    font-size: 14px;
  `
);

export const Message = styled.div`
  font-size: 12px;
  line-height: 18px;

  a {
    text-decoration: none;
    color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
  }
`;
